export const stringIsContained = ({ parent, child }) =>
  parent.toLowerCase().trim().includes(child.toLowerCase().trim());
